export const GA_LABEL = 'assortments-onboarding';
export const GA_MIGRATION_CATEGORY = 'legacy-migration';

// Onboarding
export const GA_CREATE_MESSAGE_VIEW_ACTION = 'CreateMigrationMessageView';
export const GA_CREATE_NON_ADMIN_MESSAGE_VIEW_ACTION =
    'CreateSubuserMigrationMessageView';
export const GA_COPY_MESSAGE_VIEW_ACTION = 'CopyMigrationMessageView';
export const GA_COPY_NON_ADMIN_MESSAGE_VIEW_ACTION =
    'CopySubuserMigrationMessageView';
export const GA_CREATE_MIGRATION_MSG_CLICK = 'CreateMigrationMessageClick';
export const GA_COPY_MIGRATION_MSG_CLICK = 'CopyMigrationMessageOptionsClick';
export const GA_COPY_NON_ADMIN_MIGRATION_MSG_CLICK =
    'CopySubuserMigrationMessageClick';
export const GA_CREATE_NON_ADMIN_MIGRATION_MSG_CLICK =
    'CreateSubuserMigrationMessageClick';

// Package Selection
export const GA_CREATE_MIGRATION_PACKAGE_SELECTION_VIEW =
    'CreateMigrationPackageSelectionView';
export const GA_CREATE_MIGRATION_PACKAGE_SELECTION_CLICK =
    'CreateMigrationPackageSelectionClick';
export const GA_COPY_MIGRATION_PACKAGE_SELECTION_VIEW =
    'CopyMigrationPackageSelectionView';
export const GA_COPY_MIGRATION_PACKAGE_SELECTION_CLICK =
    'CopyMigrationPackageSelectionClick';
export const GA_EVENT_CREATED = 'EventCreated';
export const GA_CREATE_EVENT = 'CreateEvent';

export const GA_P1_LABEL = 'P1';
export const GA_P1_V2_LABEL = 'P1_V2';
export const GA_P2_LABEL = 'P2';
export const GA_P3_LABEL = 'P3';
export const GA_TOP_LABEL = 'Top';
export const GA_BOTTOM_LABEL = 'Bottom';

// Change Plan
export const GA_CHANGE_PLAN_CATEGORY = 'change-plan';
export const GA_UPGRADE_CHANGE_PLAN_VIEW = 'UpgradeChangePlanView';
export const GA_UPDATE_CHANGE_PLAN_VIEW = 'UpgradeChangePlanView';
export const GA_UPGRADE_CHANGE_PLAN_CLICK = 'UpgradeChangePlanClick';
export const GA_DOWNGRADE_CHANGE_PLAN_VIEW = 'DowngradeChangePlanView';
export const GA_DOWNGRADE_CHANGE_PLAN_CLICK = 'DowngradeChangePlanClick';
export const GA_DOWNGRADE_PAGE_VIEW = 'DowngradePageView';
export const GA_DOWNGRADE_KEEP_PACKAGE = 'DowngradeKeepPackage';
export const GA_DOWNGRADE_PAGE_CLICK = 'DowngradePageClick';
export const GA_CONFLICTS_DOWNGRADE_CLICK = 'ConflictsDowngradeClick';
export const GA_CONFLICTS_DOWNGRADE_KEEP_PACKAGE =
    'ConflictsDowngradeKeepPackage';
export const GA_UPDATE_PAGE_CLICK = 'UpdatePageClick';
export const GA_CONTACT_CHANGE_PLAN_VIEW = 'ContactChangePlanView';
export const GA_CONTACT_CHANGE_PLAN_CLICK = 'ContactChangePlanClick';

// Landing Pages
export const ORG_MARKETING_CATEGORY = 'org-marketing-pages';

export const OVERVIEW_VIEW_ACTION = 'OverviewView';
export const OVERVIEW_CTA_ACTION = 'OverviewCTAClick';
export const OVERVIEW_PACKAGES_ACTION = 'OverviewPackageClick';

export const PRICING_VIEW_ACTION = 'PricingView';
export const PRICING_PACKAGE_CTA_ACTION = 'PricingPackageSelectionClick';
export const PRICING_PACKAGE_LEARN_MORE_ACTION = 'PricingPackageLearnMoreClick';
export const PRICING_COMPARE_PACKAGES_ACTION = 'PricingCompareFeaturesClick';

export const COMPARE_PACKAGES_VIEW_ACTION = 'ComparePackagesView';
export const COMPARE_PACKAGE_CTA_ACTION = 'ComparePackagesSelectionClick';

export const ESSENTIALS_VIEW_ACTION = 'EssentialsView';
export const ESSENTIALS_CTA_ACTION = 'EssentialsCTAClick';
export const ESSENTIALS_STICKY_CTA_ACTION = 'EssentialsCTAStickyClick';
export const ESSENTIALS_UPSELL_CTA_ACTION = 'EssentialsProBannerClick';

export const PROFESSIONAL_VIEW_ACTION = 'ProfessionalView';
export const PROFESSIONAL_CTA_ACTION = 'ProfessionalCTAClick';
export const PROFESSIONAL_STICKY_CTA_ACTION = 'ProfessionalCTAStickyClick';

export const PREMIUM_VIEW_ACTION = 'PremiumView';
export const PREMIUM_CTA_ACTION = 'PremiumCTAClick';
export const PREMIUM_STICKY_CTA_ACTION = 'PremiumCTAStickyClick';

export const PACKAGE_NAVIGATION_ACTION = 'PackageTabClick';

export const CREATE_EVENT_REFERRER = '/create';

// Pricing Calculator
export const GA_PRICING_CALC_CATEGORY = 'assortments-pricing-calculator';
export const FORM_CHANGE_PACKAGE_ACTION = 'ChangePackageFromForm';
export const FORM_CHANGE_TICKET_PRICE_ACTION = 'ChangeTicketPrice';
export const FORM_CHANGE_TICKET_QTY_ACTION = 'ChangeTicketQuantity';
export const FORM_CHANGE_FEE_HANDLING_ACTION = 'ChangeFeeHandling';
export const FORM_CREATE_EVENT_ACTION = 'CreateEventCTAClick';
export const FORM_CHANGE_USER_PLAN_ACTION = 'ChangeUserPlanCTAClick';
export const BANNER_TOGGLE_PACKAGE_ACTION = 'TogglePackageFromBanner';
export const FEE_BREAKDOWN_MODAL_OPEN = 'FeeBreakdownModalOpen';

// GA Package AU
export const GA_NOTIFICATION_BANNER_VIEWED = 'NotificationBannerViewed';
export const GA_PACKAGE_VIEWED = 'PackageViewed';
export const GA_PACKAGE_SELECTED = 'PackageSelected';
export const GA_PACKAGE_UPGRADED = 'PackageUpgraded';
export const GA_PACKAGE_DOWNGRADED = 'PackageDowngraded';
export const GA_PACKAGE_UPDATED = 'PackageUpdated';
export const GA_PACKAGE_BANNER_UPGRADED = 'PackageBannerUpgraded';
export const GA_PACKAGE_BANNER_VIEWED = 'PackageBannerViewed';
export const GA_PACKAGE_MODAL_UPGRADED = 'PackageModalUpgraded';
export const GA_PACKAGE_MODAL_VIEWED = 'PackageModalViewed';
export const GA_CHOOSE_PACKAGE = 'choose-package';

// Crazy Egg
export const AUSTRALIA_SNAPSHOT_NAME = 'australia_snapshot_name';
export const GLOBAL_SNAPSHOT_NAME = 'global_snapshot_name'; //rest of the world less australia

export const crazyEggSnapshotNames = {
    [AUSTRALIA_SNAPSHOT_NAME]: 'australia',
    [GLOBAL_SNAPSHOT_NAME]: 'global',
};

export const crazyEggTagName = 'crazy_egg_assortments';
export const crazyEggSnapshotTagName = 'crazy_egg_assortments_snapshot_name';

//GA Segment Package Fit Experiment
export const GA_LEARN_MORE_CLICKED = 'LearnMoreClicked';

// User Dropdown Global Header
export const GA_ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
export const GA_CATEGORY_HEADER = 'header';
export const GA_LABEL_CREATOR_EVENT = 'ViewFromConsumer';
